import React from 'react'
import PropTypes from 'prop-types'

import Raven from 'lib/raven'
import ErrorScreen from './ErrorScreen'

export default class ErrorBoundary extends React.PureComponent {
  static propTypes = {
    children: PropTypes.element,
    onActionClick: PropTypes.func.isRequired
  }

  state = {
    error: false
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error: true })
    Raven.captureException(error, { extra: errorInfo })
  }

  render() {
    if (this.state.error) {
      return <ErrorScreen onActionClick={this.props.onActionClick} />
    }

    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/components/app/ErrorBoundary.js